import React, { useState } from "react";
import "./styles/global.css";

import Navbar from "./components/Navbar/Navbar";
import {
  ComingSoonToast,
  useComingSoon,
} from "./components/ComingSoon/ComingSoon";
import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import Privacy from "./pages/Privacy/Privacy";
import Terms from "./pages/Terms/Terms";
import Support from "./pages/Support/Support";

export default function App() {
  const [activePage, setActivePage] = useState("home");
  const { visible, show: showComingSoon } = useComingSoon();

  const navigate = (page) => {
    setActivePage(page);
    window.scrollTo({ top: 0, behavior: "instant" });
  };

  return (
    <>
      <Navbar
        activePage={activePage}
        navigate={navigate}
        showComingSoon={showComingSoon}
      />

      {activePage === "home" && (
        <Home navigate={navigate} showComingSoon={showComingSoon} />
      )}
      {activePage === "about" && (
        <About navigate={navigate} showComingSoon={showComingSoon} />
      )}
      {activePage === "privacy" && (
        <Privacy navigate={navigate} showComingSoon={showComingSoon} />
      )}
      {activePage === "terms" && (
        <Terms navigate={navigate} showComingSoon={showComingSoon} />
      )}
      {activePage === "support" && (
        <Support navigate={navigate} showComingSoon={showComingSoon} />
      )}

      {/* Global toast — one instance shared across all pages */}
      <ComingSoonToast visible={visible} />
    </>
  );
}
